<template>
  <div>
    <div
      v-for="(conteneur, index) in conteneurs"
      class="row mx-0 container-align"
      :style="conteneur.style
      ? conteneur.style
      : { ...defaultStyle }"
      :key="'conteneur-'+index"
      >
      <colonne
        v-for="(colonne, colIndex) in conteneur.childElements"
        :colonne="colonne"
        :key="'colonne-'+colIndex"
        :colindex="colIndex"
        :conindex="index"
      />
    </div>
  </div>
</template>

<script>
import colonne from './colonne'
import {defaultWrapperStyle} from '../../../config/constanteUse'
export default {
  components: {
    colonne
  },
  props: {
    conteneurs: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      defaultStyle: {...defaultWrapperStyle}
    }
  }
}
</script>

<style lang="scss" scoped>
  .row{
    div[class*="col"]{
      //border-right: 1px solid lightgray;
    }
    div[class*="col"]:last-of-type{
      border: none;
    }
  }
  .container-align {
    align-items: unset !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/display/conteneur.vue